import React, { Component } from "react";

//Import Breadcrumb
import RCDisplayPage from "../../components/Common/RCDisplayPage";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
} from "../../store/functions";

class pageList_ItemType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isView: false,
      isPrint: false,
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Item Type";
    this.modalTitle = "Company Details";
    this.rtPage_Add = "AddItemType";
    this.rtPage_Edit = "EditItemType";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/ItemType";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
  }
  componentDidMount() {


    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    const LoginDetails = JSON.parse(sessionStorage.getItem("loginDetails")) || [];
    console.log("LoginDetails", LoginDetails);
    const newObj = LoginDetails.find(item => item.SubMenu == "ItemType");
    console.log("newObj", newObj);
    // Set user permissions based on newObj
    this.setState({
      isAdd: newObj?.IsAdd == 1,
      isEdit: newObj?.IsEdit == 1,
      isDelete: newObj?.IsDelete == 1,
      isView: newObj?.IsView == 1,
      isPrint: newObj?.IsPrint == 1
    });
     Fn_FillListData(this.obj, "gridData", this.API_URL + "/Id/0");
  }
  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }

  btnEdit_onClick(formData) {
    this.props.history.push(`${this.rtPage_Edit}/${formData.Id}`, {});
  }
           
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }
  renderGridHeader() {
    return (
      <>
        <th>Name</th>
        <th>HSN Code</th>
        <th>Unit</th>
       
       
      </>
    );
  }
  renderGridBody(formData) {
    return (
      <>
        <td>{formData.Name}</td>
        <td>{formData.HSNCode}</td>
        <td>{formData.Unit}</td>
      
      </>
    );
  }
  renderModalBody(selectedFormData) {
    return (
      <>
        <p className="mb-4">
         Audit Att.: <span className="text-primary">{selectedFormData.IsAuditAtt}</span>
        </p>
      </>
    );
  }
  render() {
    return (
      <div className="page-content">
      <RCDisplayPage
        //page header paramaters
        Isbreadcrumb = {true}
        breadCrumbTitle={this.breadCrumbTitle}
        breadcrumbItem={this.breadCrumbItem}
        obj={this.obj}
        //column paramaters
        isSearchBox={true}
        isSNo={true}
        isCheckBox={true}
        isViewDetails={false}
        //grid paramaters
        gridData={this.state.gridData}
        gridHeader={this.renderGridHeader}
        gridBody={this.renderGridBody}
        btnAdd_onClick={this.btnAdd_onClick}
        btnEdit_onClick={this.btnEdit_onClick}
        //delete link parameters
        confirm_alert={this.state.confirm_alert}
        success_dlg={this.state.success_dlg}
        dynamic_title={this.state.dynamic_title}
        dynamic_description={this.state.dynamic_description}
        toggleDeleteConfirm={toggleDeleteConfirm}
        toggleDeleteSuccess={toggleDeleteSuccess}
        btnDelete_onClick={this.btnDelete_onClick}
        //modal paramaters
        isOpenModal={this.state.modal}
        modalTitle={this.modalTitle}
        selectedFormData={this.state.selectedFormData}
        modalBody={this.renderModalBody}
        togglemodal={togglemodal}
        //user rights
        isAdd={this.state.isAdd}
        isEdit={this.state.isEdit}
        isDelete={this.state.isDelete}
      ></RCDisplayPage>
      </div>
    );
  }
}
export default compose(container)(pageList_ItemType);
